export const T = {
  LIGHT: 'light',
  DARK: 'dark',
  E: 'E',
  W: 'W',
  F: 'F',
  L: 'L',
  D: 'D',
  TAB_STATS: 'InHouseStats.TabStats',
  TAB_OVERVIEW: 'InHouseStats.TabOverview',
  TAB_PLAYERS: 'InHouseStats.TabPlayers',
  TAB_LINEUP: 'InHouseStats.TabLineups',
  TAB_H2H: 'InHouseStats.TabH2H',
} as const;

export type T = (typeof T)[keyof typeof T];
